var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.dynamicTags),function(tag,index){return _c('el-tag',{key:tag + index,attrs:{"size":"small","type":_vm.tagType,"closable":true,"close-transition":false},on:{"close":function($event){return _vm.handleClose(tag)}}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }